var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C4.0816 0 0.5 3.58187 0.5 8C0.5 12.4181 4.08187 16 8.5 16C12.9181 16 16.5 12.4181 16.5 8C16.5 3.58187 12.9181 0 8.5 0ZM6.64 12.8L6.63467 12.7947L6.63013 12.8L2.9 8.96L4.7744 7.0496L6.63493 8.96533L12.2349 3.20027L14.1 5.11973L6.64 12.8Z",
    fill: "#448B7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteMark);
export default __webpack_public_path__ + "static/media/complete-mark.93d56326189bb23481517d0f313e69df.svg";
export { ForwardRef as ReactComponent };